
import * as z from "zod";

export const employeeSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  role: z.enum(["admin", "manager", "staff"]),
  street: z.string().optional(),
  streetNumber: z.string().optional(),
  city: z.string().optional(),
  postcode: z.string().optional()
});

export type EmployeeFormValues = z.infer<typeof employeeSchema>;
